










import CardRoom from "./components/card room/CardRoom.vue";
import Login from "./components/Login.vue";
import Lobby from "./components/lobby/Lobby.vue";
import { Component, Vue } from "vue-property-decorator";
import { GlobalStore } from "./stores/GlobalStore";
import { View } from "./Constants";

@Component({
  components: {
    CardRoom,
    Login,
    Lobby
  }
})
export default class App extends Vue {
  // private roomConfig: RoomConfig = new RoomConfig(STANDARD_CARD_CONFIG, 8);
  private globalStore: GlobalStore = new GlobalStore(true);

  get isLoggedIn() {
    return this.globalStore.isLoggedIn();
  }

  get showCardTable() {
    return this.globalStore.activeView === View.CardTable;
  }

  get showLobby() {
    return this.globalStore.activeView === View.Lobby;
  }
}
